import type { IconSvgObject } from './types';

const BookmarkAdd02Icon: IconSvgObject = [
  ["path", { d: "M21 5.5H14M17.5 2V9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.5 3H5C3.89543 3 3 3.89543 3 5V22L10.5 18L18 22V12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookmarkAdd02Icon;
